export default {
  title: "Нови резултати",
  subtitle: "Наскоро получени лабораторни резултати",
  comingSoon: "Очаквайте скоро",
  description: "Тази функция ще показва най-новите получени лабораторни резултати.",
};
